/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventimages1Inputs */

const en_eventimages1 = /** @type {(inputs: Eventimages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Images`)
};

const de_eventimages1 = /** @type {(inputs: Eventimages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventbilder`)
};

/**
* | output |
* | --- |
* | "Event Images" |
*
* @param {Eventimages1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventimages1 = /** @type {((inputs?: Eventimages1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventimages1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventimages1(inputs)
	return de_eventimages1(inputs)
});
export { eventimages1 as "eventImages" }